"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtaPremiumWording = void 0;
var MtaPremiumWording = /** @class */ (function () {
    function MtaPremiumWording(premiumWording, successModalBodyWording, isGenericModalBodyWording) {
        this.premiumWording = premiumWording;
        this.successModalBodyWording = successModalBodyWording;
        this.isGenericModalBodyWording = isGenericModalBodyWording;
    }
    return MtaPremiumWording;
}());
exports.MtaPremiumWording = MtaPremiumWording;
//# sourceMappingURL=MtaPremiumWording.js.map